import { useState } from "react";
import { AudioPlayer } from "@/components/AudioPlayer";
import { BottomMenu } from "@/components/BottomMenu";
import { NewsOverlay } from "@/components/NewsOverlay";

const Index = () => {
  const [newsOpen, setNewsOpen] = useState(false);

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4 pb-24">
      <div className="w-full max-w-md space-y-6 text-center">
        <img 
          src="https://cfrradio.com/wp-content/uploads/2024/08/River-Rat-Logo.png" 
          alt="River Rat Radio"
          className="w-1/2 mx-auto h-auto mb-6"
        />
        <AudioPlayer />
      </div>
      
      <BottomMenu 
        onRefresh={handleRefresh}
        onNewsClick={() => setNewsOpen(true)}
      />
      
      <NewsOverlay 
        open={newsOpen}
        onOpenChange={setNewsOpen}
      />
    </div>
  );
};

export default Index;